import Dropdown from 'bootstrap/js/dist/dropdown';
import Tooltip from 'bootstrap/js/dist/tooltip';
import Popover from 'bootstrap/js/dist/popover';
import Modal from 'bootstrap/js/dist/modal';
// import Collapse from 'bootstrap/js/dist/collapse';
import Toast from 'bootstrap/js/dist/toast';
import Offcanvas from 'bootstrap/js/dist/offcanvas';
// import ScrollSpy from 'bootstrap/js/dist/scrollspy';
import Tab from 'bootstrap/js/dist/tab';
// import Alert from 'bootstrap/js/dist/alert';
// import Button from 'bootstrap/js/dist/button';
// import Carousel from 'bootstrap/js/dist/carousel';

window.bootstrap = {
    Dropdown,
    Tooltip,
    Popover,
    Toast,
    Modal,
    Offcanvas,
    Tab
}

// Initialize Bootstrap components that require JavaScript
document.addEventListener('DOMContentLoaded', () => {
    // Initialize tooltips for elements with data-bs-toggle="tooltip"
    const tooltipTriggerList = [].slice.call(document.querySelectorAll('[data-bs-toggle="tooltip"]'));
    tooltipTriggerList.forEach((tooltipTriggerEl) => {
        new Tooltip(tooltipTriggerEl);
    });

    // Initialize popovers for elements with data-bs-toggle="popover"
    const popoverTriggerList = [].slice.call(document.querySelectorAll('[data-bs-toggle="popover"]'));
    popoverTriggerList.forEach((popoverTriggerEl) => {
        new Popover(popoverTriggerEl);
    });

    // Automatically initialize all Toast components
    const toastElList = [].slice.call(document.querySelectorAll('.toast'));
    toastElList.forEach((toastEl) => {
        const toast = new Toast(toastEl);
        toast.show();
    });

    /*Bootstrap validation*/
    const forms = document.querySelectorAll('.needs-validation')
    Array.from(forms).forEach(form => {
        form.addEventListener('submit', event => {
            if (!form.checkValidity()) {
                event.preventDefault();
                event.stopPropagation();
            }
            form.classList.add('was-validated')
        }, false)
    })

    // Select all elements with data-bs-toggle="dropdown"
    const dropdownElementList = [].slice.call(document.querySelectorAll('[data-bs-toggle="dropdown"]'));
    dropdownElementList.forEach((dropdownToggleEl) => {
        new Dropdown(dropdownToggleEl);
    });
});

